// extracted by mini-css-extract-plugin
module.exports = {"filterItem":"filterItem_filterItem_1sRgaHI","label":"filterItem_label_tF01iTX"};